const request = async (
  url,
  body,
  method = "GET",
  // type = "application/json",
  token = null
) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    method,
    body,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (response.ok) return result;
  const err = result.error || result.message || result;
  throw new Error(
    /(!)/gim.test(err) ? err : "Something went wrong, please try again later."
  );
};

export const requestget = async (url, token) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (response.ok) return result;
  const err = result.error || result.message || result;
  throw new Error(
    /(!)/gim.test(err) ? err : "Something went wrong, please try again later."
  );
};

export const requestpost = async (url, body, token) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (response.ok) return result;
  const err = result.error || result.message || result;
  return /(!)/gim.test(err)
    ? err
    : "Something went wrong, please try again later.";
};

export const requestdelete = async (url, token) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (response.ok) return result;
  const err = result.error || result.message || result;
  return /(!)/gim.test(err)
    ? err
    : "Something went wrong, please try again later.";
};

export const requestPatch = async (url, body, token) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
    method: "PATCH",
    body,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (response.ok) return result;
  const err = result.error || result.message || result;
  return /(!)/gim.test(err)
    ? err
    : "Something went wrong, please try again later.";
};

export default request;
